import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: "What if I don't have footage?",
      answer: "No problem! We can provide visuals based on your vision. We use a combination of stock footage, AI-generated visuals, motion graphics, and creative editing to bring your story to life - even if you don't have any existing footage or images."
    },
    {
      question: 'Do you provide scripts?',
      answer: "Yes! Script support is included in our packages. We'll work with you to craft compelling narratives that resonate with your audience and capture the essence of your thriller."
    },
    {
      question: 'What formats do I get?',
      answer: "The formats depend on your package. The Cinematic Trailer includes your chosen format (vertical or horizontal). The Trailer + Promo Cuts package includes both vertical and horizontal formats optimized for TikTok, Instagram Reels, YouTube Shorts, and more."
    },
    {
      question: 'How long does it take to complete a video?',
      answer: 'The Cinematic Trailer is delivered in 7-10 business days. The Trailer + Promo Cuts package takes 10-14 business days. Rush options are available at an additional cost.'
    },
    {
      question: 'What do I need to provide to get started?',
      answer: "At minimum: your book synopsis, cover art, target audience info, and your goals for the trailer. If you have footage, images, or mood references - great! If not, we'll fill in the gaps creatively."
    },
    {
      question: 'How many revisions are included?',
      answer: 'The Cinematic Trailer includes 2 revisions. The Trailer + Promo Cuts package includes 3 revisions. Additional revisions can be purchased as needed.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-[#0A0A0A] relative overflow-hidden" data-testid="faq-section">
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-heading tracking-tight uppercase mb-6" data-testid="faq-heading">
            <span className="text-white">Frequently Asked </span>
            <span className="text-gradient-noir">Questions</span>
          </h2>
          <p className="text-base text-gray-500">
            Got questions? We've got answers.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-[#0A0A0A] border border-white/10 hover:border-red-700/30 px-6 transition-all duration-300 rounded-none"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left text-base font-semibold text-white hover:text-red-500 py-5 [&[data-state=open]]:text-red-500 font-['Manrope',sans-serif]" data-testid={`faq-trigger-${index}`}>
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 text-sm leading-relaxed pb-5" data-testid={`faq-content-${index}`}>
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional Help */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Still have questions?{' '}
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-red-500 hover:text-red-400 underline font-semibold transition-colors duration-200"
              data-testid="faq-contact-link"
            >
              Contact us
            </button>
            {' '}and we'll be happy to help!
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
